module.exports = __webpack_public_path__ + "static/media/Torchic_gaussian2.3558d000.png";